module.exports = __webpack_public_path__ + "img/猜你喜欢推送6.c230b84f.gif";